// extracted by mini-css-extract-plugin
export default {"root":"mo7_wR2"};